import * as React from "react";
import { CircleCheckBig, TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BusinessReportOutcomeDetails } from "@/modules/snapshots/businessReports.types";
import { useUpdateBusinessReportOutcomeMutation } from "@/modules/snapshots/businessReports.api";
import TopBarProgress from "react-topbar-progress-indicator";
import { useSnapshotPermission } from "@/modules/snapshots/hooks/useSnapshotPermission";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";

interface Props {
  businessReportOutcome: BusinessReportOutcomeDetails;
}

export const BusinessReportOutcomeVerify: React.FC<Props> = ({ businessReportOutcome }) => {
  const [updateBusinessReportOutcome, { isLoading }] = useUpdateBusinessReportOutcomeMutation();
  const handleClick = () => {
    updateBusinessReportOutcome({ id: businessReportOutcome.id, data: { verified: !businessReportOutcome.verified } });
  };

  const user = useAuthenticatedUser();
  const isOwner = useSnapshotPermission(businessReportOutcome);
  // A published family summary row is verified by whoever can see it (a viewer of the Master
  // Collection); the backend accepts nothing else about such a row.
  const canVerifyFamilyRow =
    Boolean(businessReportOutcome.summary_row_kind) &&
    businessReportOutcome.permissions.some(permission => permission.user_id === user.id);
  const isReadOnly = !(isOwner || canVerifyFamilyRow);

  return (
    <>
      {isLoading && <TopBarProgress />}
      {!businessReportOutcome.verified ? (
        <Button variant="outline" size="sm" disabled={isLoading || isReadOnly} onClick={handleClick}>
          <TriangleAlert className="mr-1.5 size-4" />
          Verify
        </Button>
      ) : (
        <Button variant="outline" size="sm" disabled={isLoading || isReadOnly} onClick={handleClick}>
          <CircleCheckBig className="mr-1.5 size-4" />
          Verified
        </Button>
      )}
    </>
  );
};
